/* eslint-disable */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ECharts from 'echarts-for-react';
import Papa from 'papaparse';
import { Box, Tab, Table, TableBody, TableCell, TableContainer, TableRow, Tabs, colors } from "@mui/material";
import { getDiagnosisResultNoiseByDayByQuery, getDiagnosisResultVibrationSensorsGraphDayByQuery, getEquipmentTemperatureGraphDayByQuery } from "components/axios/equipmentAlertsAxios";
import MainCard from "components/MainCard";
import { getBatLevelImgByBatLevel, getDiagnosisGradeColor } from "data/data";
import CSVReaderGraphTab from "./CSVReaderGraphTab";
import EquipmentPartSensorsGraphsLayer from "components/layer/EquipmentPartSensorsGraphsLayer";
import { getDownloadDirectByQuery } from "components/axios/fileManagerAxios";
import { useEnumApi } from "contexts/EnumApiContext";
import dayjs from "dayjs";
import { useTheme } from "components/ThemeContext";

function EquipmentPartSensorsGraphs({equipment, equipmentPartId, sensorPosition, equipmentPartPosition, type="none"}) {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const [equipmentPartName, setEquipmentPartName] = useState('');
    const { t } = useTranslation();
    
    const { mode } = useTheme();
    const textColor = mode === 'white' ? '#262626' : '#ffffff';
    const bgColor = mode === 'white' ? '#f9f9fa' : '#2f2f2f';

    const chartDataInit = {
        chart: {
            background: '#2f2f2f',
            foreColor: '#ffffff',
        },
        textStyle : {
            color : textColor
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data : [],
            left : 'center',
            top: 0,
            backgroundColor : bgColor,
            textStyle: {
                color: textColor
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [ ]
        },
        yAxis: {
            type: 'value'
        },
        series: [ ]
    }

    const [options, setOptions] = useState({chartDataInit});
    const [tempOptions, setTempOptions] = useState({chartDataInit});

    const [csvOptions, setCsvOptions] = useState({chartDataInit});
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [remainLife, setRemainLife] = useState(0); 
    useEffect(()=>{
        // console.log(chartDataInit)
        if(sensorPosition) {
            // let graphParam = {"equipmentId":equipment.id};
            // let graphVibrationParam = {"equipmentPart.id":equipmentPartId, position : (sensorPosition.sensorType+'_'+sensorPosition.positionNoBySensorType)};
            let graphVibrationParam = {"sensorPosition.id":sensorPosition.id};
            setOptions(null)
            setTempOptions(null)
            if (sensorPosition.sensorType === 'V') {    // 진동센서
                getDiagnosisResultVibrationSensorsGraphDayByQuery(graphVibrationParam).then((data)=> {
                  if (data && data._embedded) {
                        let list = data._embedded.groupByDailyDiagnosisResultVibrations;
                        list.sort(function(a,b) {
                            const upperCaseA = a.ymd.toUpperCase();
                            const upperCaseB = b.ymd.toUpperCase();
                            if (upperCaseA > upperCaseB) return 1;
                            if (upperCaseA < upperCaseB) return -1;
                            if (upperCaseA === upperCaseB) return 0;
                        });
                        let optionsCopy = {...chartDataInit};
                        let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
                        
                        let overallXs = [];
                        let overallYs = [];
                        let overallZs = [];
                        list.map(function(item, i) {
                            chartDataCopy.xAxis.data.push(item.ymd);
                            overallXs.push(item.overallShaft.toFixed(2));
                            overallYs.push(item.overallHorizon.toFixed(2));
                            overallZs.push(item.overallVertical.toFixed(2));
                            if (i==0) {
                                setEquipmentPartName(item.equipmentPartName)
                            }
                        });
                        chartDataCopy.series.push({name:t('message.common.subtitle.axis'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : overallXs});
                        chartDataCopy.series.push({name:t('message.common.subtitle.radius'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : overallYs});
                        chartDataCopy.series.push({name:t('message.common.subtitle.vertical'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : overallZs});
                        chartDataCopy.legend.data.push(t('message.common.subtitle.axis'));
                        chartDataCopy.legend.data.push(t('message.common.subtitle.radius'));
                        chartDataCopy.legend.data.push(t('message.common.subtitle.vertical'));
                        setOptions(chartDataCopy);
                    } else {
                        setOptions(null);
                    }
                })
            } else if (sensorPosition.sensorType === 'N') { // 소음센서
                getDiagnosisResultNoiseByDayByQuery(graphVibrationParam).then((data)=>{
                    if (data && data._embedded) {
                        let list = data._embedded.groupByDailyDiagnosisResultNoises;
                        // console.log(list)
                        list.sort(function(a,b) {
                            const upperCaseA = a.ymd.toUpperCase();
                            const upperCaseB = b.ymd.toUpperCase();
                            if (upperCaseA > upperCaseB) return 1;
                            if (upperCaseA < upperCaseB) return -1;
                            if (upperCaseA === upperCaseB) return 0;
                        });
                        let optionsCopy = {...chartDataInit};
                        let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
                        
                        let rmss = [];
                        let skewness = [];
                        let kurtosis = [];
                        list.map(function(item, i) {
                            chartDataCopy.xAxis.data.push(item.ymd);
                            rmss.push(item.rms.toFixed(2));
                            skewness.push(item.skew.toFixed(2));
                            kurtosis.push(item.kurtosis.toFixed(2));
                            if (i==0) {
                                setEquipmentPartName(item.equipmentPartName)
                            }
                        });
                        chartDataCopy.series.push({name:'RMS', type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : rmss});
                        chartDataCopy.series.push({name:t('message.common.subtitle.skewness'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : skewness});
                        chartDataCopy.series.push({name:t('message.common.subtitle.kurtosis'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : kurtosis});
                        chartDataCopy.legend.data.push('RMS');
                        chartDataCopy.legend.data.push(t('message.common.subtitle.skewness'));
                        chartDataCopy.legend.data.push(t('message.common.subtitle.kurtosis'));
                        setOptions(chartDataCopy);
                    } else {
                        setOptions(null);
                    }
                })
            }

            getEquipmentTemperatureGraphDayByQuery(graphVibrationParam).then((data)=>{
                // console.log(data)
                if (data && data._embedded) {
                    let list = data._embedded.groupByDailyEquipmentTemperatures;
                    list.sort(function(a,b) {
                        const upperCaseA = a.ymd.toUpperCase();
                        const upperCaseB = b.ymd.toUpperCase();
                        if (upperCaseA > upperCaseB) return 1;
                        if (upperCaseA < upperCaseB) return -1;
                        if (upperCaseA === upperCaseB) return 0;
                    });
                    let optionsCopy = {...chartDataInit};
                    let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
                    
                    let temperatures = [];
                    list.map(function(item, i) {
                        chartDataCopy.xAxis.data.push(item.ymd);
                        temperatures.push((item.temperature).toFixed(2));
                    });
                    chartDataCopy.series.push({name:t('message.common.subtitle.temperature'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : temperatures});
                    chartDataCopy.legend.data.push(t('message.common.subtitle.temperature'));
                    setTempOptions(chartDataCopy);
                } else {
                    setTempOptions(null);
                }
            })

            getDownloadDirectByQuery({fileGroup:"LER",id:equipmentPartId+'_'+sensorPosition.sensorType+'_'+sensorPosition.positionNoBySensorType}).then((res) => {
                return res;
            }).then((blob) => {
                setFile(blob);
                setIsLoading(true);
            })
            .catch((err) => {
                setFile(null);
                setIsLoading(false);
            });
        }
    },[sensorPosition, equipment, mode]);

    useEffect(()=>{
        if (isLoading) {
          handleParse();
        }
    },[isLoading]);

    const handleParse = () => {
        const reader = new FileReader();
        reader.onload = async ({ target }) => {
          const csv = Papa.parse(target.result, { header: true });
          const parsedData = csv?.data;
          const columns = Object.keys(parsedData[0]);
          const datas = parsedData[0];
          setRemainLife(parseInt(datas[columns[3]]));
          let optionsCopy = {...chartDataInit};
          let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
          let lifeSpans = [];
          let remainLifeSpans = [];
          parsedData.map(function(row, i) {
            if (row[columns[0]] && row[columns[0]] !== '') {
              chartDataCopy.xAxis.data.push(row[columns[0]]);
              lifeSpans.push((Math.round(row[columns[1]]*100)/100 || 0));
              remainLifeSpans.push((Math.round(row[columns[2]]*100)/100 || 0));
            }
          });
          chartDataCopy.series.push({name:t('message.common.text.lifespan.index'), type: 'line', areaStyle: {}, data : lifeSpans});
          chartDataCopy.series.push({name:t('message.common.text.expect.lifespan.index'), type: 'line', areaStyle: {}, data : remainLifeSpans});
          chartDataCopy.legend.data.push(t('message.common.text.lifespan.index'));
          chartDataCopy.legend.data.push(t('message.common.text.expect.lifespan.index'));
          setCsvOptions(chartDataCopy);
          // setLifeSpanGraphDatas(chartDataCopy);
        };
        reader.readAsText(file);
    };

    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    if (options || tempOptions || (isLoading && csvOptions !== null && remainLife !== 0)) {
        let className = '';
        if (type === 'popup') className='pop_tr';
    return (
        <>
            <TableContainer>
                <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width">
                    <TableBody>
                        {equipment.iotInstlYn && (value === 0 && options) &&
                        <TableRow className={className}>
                            <TableCell className="th" align="center">{t('message.common.select.sensor')}</TableCell>
                            <TableCell align="center">
                                {getEnumValueByEnumNameAndCode("SensorType", sensorPosition.sensorType) && getEnumValueByEnumNameAndCode("SensorType", sensorPosition.sensorType)[0].title} ({sensorPosition.positionNoBySensorType})
                                {(sensorPosition.sensor?.batLevel === 0 || sensorPosition.sensor?.batLevel) && <img className="bat" style={{margin:"-1.2px 0 0 5px", width:"25px"}} src={`${process.env.PUBLIC_URL}/img/icon/${getBatLevelImgByBatLevel(sensorPosition.sensor?.batLevel)}`} alt={sensorPosition.sensor?.batLevel} title={sensorPosition.sensor?.batLevel} />}
                            </TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.diagnosis.value')}</TableCell>
                            <TableCell align="center" colSpan={3}>
                                {(value === 0 && options) && sensorPosition.diagnosisResultVibration &&
                                <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                    {t('message.common.subtitle.axis')} : <div align="center"><span>{sensorPosition.diagnosisResultVibration.overall_shaft.toFixed(2)}</span></div>
                                    &nbsp;&nbsp;{t('message.common.subtitle.radius')} : <div align="center"><span>{sensorPosition.diagnosisResultVibration.overall_horizon.toFixed(2)}</span></div>
                                    &nbsp;&nbsp;{t('message.common.subtitle.vertical')} : <div align="center"><span>{sensorPosition.diagnosisResultVibration.overall_vertical.toFixed(2)}</span></div>
                                    {/* {sensorPosition.equipmentTemperature &&
                                    <>&nbsp;&nbsp;{t('message.common.subtitle.temperature')} : <div align="center"><span>{sensorPosition.equipmentTemperature.temperature.toFixed(2)}</span></div></>
                                    } */}
                                </div>
                                }
                                {(value === 0 && options) && sensorPosition.diagnosisResultNoise &&
                                <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                    RMS : <div align="center"><span>{sensorPosition.diagnosisResultNoise.rms.toFixed(2)}</span></div>
                                    &nbsp;&nbsp;{t('message.common.subtitle.skewness')} : <div align="center"><span>{sensorPosition.diagnosisResultNoise.skew.toFixed(2)}</span></div>
                                    &nbsp;&nbsp;{t('message.common.subtitle.kurtosis')} : <div align="center"><span>{sensorPosition.diagnosisResultNoise.kurtosis.toFixed(2)}</span></div>
                                    {/* {sensorPosition.equipmentTemperature &&
                                    <>&nbsp;&nbsp;{t('message.common.subtitle.temperature')} : <div align="center"><span>{sensorPosition.equipmentTemperature.temperature.toFixed(2)}</span></div></>
                                    } */}
                                </div>
                                }
                            </TableCell>
                        </TableRow>
                        }
                        {equipment.iotInstlYn && (value === 0 && options) && sensorPosition.diagnosisResultVibration &&
                        <TableRow className={className}>
                            <TableCell className="th" align="center">{t('message.common.subtitle.diagnosis.date')}</TableCell>
                            <TableCell align="center">
                                {dayjs(sensorPosition.diagnosisResultVibration.analysis_at).format("YYYY-MM-DD")}
                            </TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.diagnosis.result')}</TableCell>
                            <TableCell align="center" colSpan={3}>
                                <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                    {t('message.common.subtitle.axis')} : <div align="center" className={getDiagnosisGradeColor(sensorPosition.diagnosisResultVibration.rank_shaft)}><span>{sensorPosition.diagnosisResultVibration.rank_shaft}</span></div>
                                    {t('message.common.subtitle.radius')} : <div align="center" className={getDiagnosisGradeColor(sensorPosition.diagnosisResultVibration.rank_horizon)}><span>{sensorPosition.diagnosisResultVibration.rank_horizon}</span></div>
                                    {t('message.common.subtitle.vertical')} : <div align="center" className={getDiagnosisGradeColor(sensorPosition.diagnosisResultVibration.rank_vertical)}><span>{sensorPosition.diagnosisResultVibration.rank_vertical}</span></div>
                                </div>
                            </TableCell>
                        </TableRow>
                        }
                        {equipment.iotInstlYn && (value === 0 && options) && sensorPosition.diagnosisResultNoise &&
                        <TableRow className={className}>
                            <TableCell className="th" align="center">{t('message.common.subtitle.diagnosis.date')}</TableCell>
                            <TableCell align="center">
                                {dayjs(sensorPosition.diagnosisResultNoise.analysis_at).format("YYYY-MM-DD")}
                            </TableCell>
                            <TableCell className="th" align="center"></TableCell>
                            <TableCell align="center" colSpan={3}></TableCell>
                        </TableRow>
                        }

                        {equipment.iotInstlYn && (value === 1 && tempOptions) && sensorPosition.diagnosisResultVibration &&
                        <TableRow className={className}>
                            <TableCell className="th" align="center">{t('message.common.select.sensor')}</TableCell>
                            <TableCell align="center">{getEnumValueByEnumNameAndCode("SensorType", sensorPosition.sensorType) && getEnumValueByEnumNameAndCode("SensorType", sensorPosition.sensorType)[0].title} ({sensorPosition.positionNoBySensorType})</TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.diagnosis.value')}</TableCell>
                            <TableCell align="center" colSpan={3}>
                                <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                    {sensorPosition.equipmentTemperature &&
                                    <>&nbsp;&nbsp;{t('message.common.subtitle.temperature')} : <div align="center"><span>{sensorPosition.equipmentTemperature.temperature.toFixed(2)}</span></div></>
                                    }
                                </div>
                            </TableCell>
                        </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            <div className="row">
                <div className="mixed-chart">
                    <Box>
                        <Tabs value={value} onChange={handleChange} style={{paddingTop:"10px", paddingLeft:"10px"}} sx={{ ".Mui-selected":{bgcolor:"#0a2e60"} }}>
                            {options && <Tab vlue={0}
                                className="graphTab"
                                label={
                                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                                    {(sensorPosition && sensorPosition.sensorType === 'V' ? t('message.common.chip.vibration.trend.graph') : t('message.common.chip.grade.history.trend.graph'))+" ("+equipmentPartName+")"}
                                    {/* {(sensorPosition && sensorPosition.sensorType === 'V' ? t('message.common.chip.vibration.trend.graph') : t('message.common.chip.noise.trend.graph'))} */}
                                    &nbsp;&nbsp;
                                    <EquipmentPartSensorsGraphsLayer equipment={equipment} sensorPosition={sensorPosition} equipmentPartId={equipmentPartId} 
                                        equipmentPartPosition={equipmentPartPosition} equipmentPartName={equipmentPartName} />
                                    </Box>
                                }
                            />
                            }
                            {tempOptions && <Tab value={1} label={
                                <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                                {t('message.common.chip.temperature.trend.graph')}
                                &nbsp;&nbsp;
                                <EquipmentPartSensorsGraphsLayer equipment={equipment} sensorPosition={sensorPosition} equipmentPartId={equipmentPartId} 
                                    equipmentPartPosition={equipmentPartPosition} equipmentPartName={equipmentPartName} type="S1" />
                                </Box>
                                } className="graphTab" />}
                            {isLoading && csvOptions !== null && remainLife !== 0 &&
                            <Tab value={2} label={`${t('message.common.chip.expect.lifespan')} (${t('message.common.chip.remain.lifespan')}:${remainLife}${t('message.common.text.month')})`} className="graphTab" />
                            }
                        </Tabs>
                        <Box mt={2}>
                            {value === 0 && options &&
                                <MainCard content={false}>
                                    {/* <EquipmentPartSensorsGraphsLayer equipment={equipment} sensor={sensor} equipmentPartPosition={equipmentPartPosition} equipmentPartName={equipmentPartName} /> */}
                                    <ECharts
                                      key={mode}
                                      option={options}
                                      opts={{ renderer: 'svg', height: '300px' }}
                                      />
                                </MainCard>
                            }
                            {value === 1 && tempOptions &&
                                <MainCard content={false}>
                                    <ECharts
                                      key={mode}
                                    option={tempOptions}
                                    opts={{ renderer: 'svg', height: '300px' }}
                                    />
                                </MainCard>
                            }
                            {value === 2 && isLoading && csvOptions !== null && remainLife !== 0 &&
                                <CSVReaderGraphTab options={csvOptions} remainLife={remainLife} isLoading={isLoading} />
                            }
                        </Box>
                    </Box>
                </div>
            </div>
            <div className="divide" />
        </>
    )
   }
}

export default EquipmentPartSensorsGraphs;